export function listAdapter({ account_id: accountId, archived, created_at: createdAt, id: listKey, name, updated_at: updatedAt, total, created_by_full_name: createdByFullName, user_id: userId, }) {
    return {
        accountId: String(accountId),
        archived,
        createdAt,
        listKey,
        name,
        updatedAt,
        total: Number(total),
        createdByFullName,
        userId,
    };
}
// This is a quick fix to handle cases where the url protocol exists in the company domain.
// In this case we switch between the company URL and the domain.
const getCompanyLinks = (homepage, homepageUrl) => {
    if (!homepage || !homepageUrl) {
        return { domain: '', homepageUrl: '' };
    }
    const domainHasProtocol = homepage.indexOf('http://') === 0 || homepage.indexOf('https://') === 0;
    return {
        domain: domainHasProtocol ? homepageUrl : homepage,
        homepageUrl: domainHasProtocol ? homepage : homepageUrl,
    };
};
const isObject = val => typeof val === 'object';
export const savedContactsCompany = companyData => {
    var _a, _b, _c, _d, _e, _f;
    const { domain, homepageUrl } = getCompanyLinks(companyData.homepage, companyData.homepage_url);
    return {
        domains: {
            homepage: domain.replace('www.', ''),
        },
        location: {
            city: companyData.city,
            state: companyData.state,
            country: companyData.country,
        },
        company_size: {
            min: (_a = companyData.company_size) === null || _a === void 0 ? void 0 : _a[0],
            max: (_b = companyData.company_size) === null || _b === void 0 ? void 0 : _b[1],
        },
        name: companyData.name,
        hasCompany: !!homepageUrl,
        description: companyData.description,
        logo_url: companyData.logo_url,
        homepage_url: homepageUrl,
        founded: companyData.founded,
        industry_primary_group: (_d = (_c = companyData.industry) === null || _c === void 0 ? void 0 : _c.primary_industry) === null || _d === void 0 ? void 0 : _d.key,
        industry_tags: companyData.industry_tags,
        social: {
            LinkedIn: isObject(companyData === null || companyData === void 0 ? void 0 : companyData.linkedin) ? companyData === null || companyData === void 0 ? void 0 : companyData.linkedin.url : companyData === null || companyData === void 0 ? void 0 : companyData.linkedin,
            facebook: isObject(companyData === null || companyData === void 0 ? void 0 : companyData.facebook) ? companyData === null || companyData === void 0 ? void 0 : companyData.facebook.url : companyData === null || companyData === void 0 ? void 0 : companyData.facebook,
            twitter: isObject(companyData === null || companyData === void 0 ? void 0 : companyData.twitter) ? companyData === null || companyData === void 0 ? void 0 : companyData.twitter.url : companyData === null || companyData === void 0 ? void 0 : companyData.twitter,
        },
        revenue_range: {
            min: (_e = companyData === null || companyData === void 0 ? void 0 : companyData.company_revenue) === null || _e === void 0 ? void 0 : _e[0],
            max: (_f = companyData === null || companyData === void 0 ? void 0 : companyData.company_revenue) === null || _f === void 0 ? void 0 : _f[1],
        },
    };
};
export const editedContactAdapter = contactData => {
    var _a, _b;
    return ({
        emails: contactData.emails.map((email, index) => {
            var _a;
            const metadata = contactData.emails_metadata[index];
            return {
                address: email,
                is_work_email: metadata.label === 'work',
                isEdited: !!metadata.isEdited,
                isManuallyAdded: !!metadata.isManuallyAdded,
                isShown: !!((_a = metadata === null || metadata === void 0 ? void 0 : metadata.split_credits) === null || _a === void 0 ? void 0 : _a.shown_date),
            };
        }),
        phones: contactData.phones.map((number, index) => {
            var _a;
            const metadata = contactData.phones_metadata[index];
            return {
                text: number,
                isEdited: !!metadata.isEdited,
                isManuallyAdded: !!metadata.isManuallyAdded,
                type: metadata.type,
                isShown: !!((_a = metadata === null || metadata === void 0 ? void 0 : metadata.split_credits) === null || _a === void 0 ? void 0 : _a.shown_date),
            };
        }),
        jobTitle: {
            title: ((_a = contactData.job_title) === null || _a === void 0 ? void 0 : _a.title) || '',
            editedFields: ((_b = contactData.job_title) === null || _b === void 0 ? void 0 : _b.edited) || [],
        },
    });
};
export const savedContactsAdapter = result => {
    const phones = result.contactPhones.map(metadata => ({
        text: metadata.number,
        isEdited: metadata.isEdited,
        isManuallyAdded: metadata.isManuallyAdded,
        do_not_call: metadata.do_not_call || null,
        is_revealed: !metadata.isMasked,
        id: metadata.datapointId,
        status: metadata.isMasked ? 'masked' : 'shown',
    }));
    const emails = result.contactEmails.map(metadata => ({
        address: metadata.address,
        is_work_email: metadata.label === 'work',
        isEdited: metadata.isEdited,
        isManuallyAdded: metadata.isManuallyAdded,
        is_revealed: !metadata.isMasked,
        id: metadata.datapointId,
        status: metadata.isMasked ? 'masked' : 'shown',
    }));
    let savedContact = {
        isShown: true,
        contactId: result.id,
        id: result.id,
        listId: result.lists.split(',')[result.lists.split(',').length - 1],
        showDate: result.showDate,
        tags: result.tags,
        company: result.companyData,
        emails,
        phones,
        integrations: result.integration,
        fullName: result.contactName,
        jobTitle: result.jobTitle,
        wishlistContact: null,
        canShowContact: result.canShowContact,
        maskedId: result.maskId,
        maskedContactId: result.datapointContactId,
    };
    if (result.contactType === 'WISHED') {
        const wishlistContact = {
            id: result.id,
            firstName: result.firstName,
            lastName: result.lastName,
            jobTitle: result.jobTitle || {},
            phones: result.contactPhones.map(metadata => ({ type: metadata.label, value: metadata.number })),
            emails: result.contactEmails.map(metadata => ({ type: metadata.label, value: metadata.address })),
            company: result.companyData,
            integrations: result.integration,
            contactLists: result.lists.split(','),
            contactTags: result.tags,
            contactType: 'WISHLIST_CONTACT',
        };
        return {
            contactId: result.id,
            company: result.companyData,
            phones: [],
            emails: [],
            fullName: result.contactName,
            wishlistContact,
        };
    }
    if (result.contactType === 'UNSHOWN') {
        savedContact = Object.assign(Object.assign({}, savedContact), { isShown: false, contactType: 'UNSHOWN_CONTACT' });
    }
    return savedContact;
};
export const contactAdapter = ({ showDate, id, account_id: accountId, api_version: apiVersion, companyDetails, datapoints, emails, location, firstName, lastName, acquire_status: acquireStatus, phones, socialLinks, feedback, group_id: groupId, integrations, job_title: jobTitle, platform, request_id: requestId, search_version: searchVersion, url, uuid, user_id: userId, userName, otherLists: lists, tags, type: contactType, job, datapointContactId, canShowContact, }, maskId) => {
    var _a;
    return ({
        showDate,
        id,
        _accountId: accountId,
        apiVersion,
        companyData: companyDetails,
        contactEmails: datapoints === null || datapoints === void 0 ? void 0 : datapoints.emails.map(email => (Object.assign({ address: email.value }, email))),
        contactLocation: location,
        contactName: `${firstName} ${lastName}`,
        contactPhones: datapoints === null || datapoints === void 0 ? void 0 : datapoints.phones.map(phone => (Object.assign({ number: phone.value }, phone))),
        contactSocialLinks: socialLinks === null || socialLinks === void 0 ? void 0 : socialLinks.linkedin,
        emails,
        feedback,
        firstName,
        name: `${firstName} ${lastName}`,
        acquireStatus,
        groupId,
        integration: integrations,
        jobTitles: jobTitle,
        lastName,
        lists: lists === null || lists === void 0 ? void 0 : lists.map(list => list.listId).join(','),
        listsData: lists,
        phones,
        platform,
        request_id: requestId,
        searchVersion,
        url,
        uuid,
        userId,
        userName,
        jobTitle: job,
        jobSeniority: (job === null || job === void 0 ? void 0 : job.seniority) || '',
        jobDepartment: ((_a = job === null || job === void 0 ? void 0 : job.departments) === null || _a === void 0 ? void 0 : _a.join(', ')) || '',
        tags,
        contactType,
        maskId,
        datapointContactId,
        canShowContact,
    });
};
